import React from 'react';
import { motion } from 'framer-motion';
import { WhatsAppIcon } from './WhatsAppIcon';
export const FloatingWhatsApp = () => {
  return <motion.a href="https://wa.me/584244582867" target="_blank" rel="noreferrer" aria-label="Escríbenos por WhatsApp" initial={{
    opacity: 0,
    scale: 0.6,
    y: 30
  }} animate={{
    opacity: 1,
    scale: 1,
    y: 0
  }} transition={{
    delay: 1,
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1]
  }} className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-[100] group" data-id="element-37">
      {/* Pulsing rings */}
      <span className="absolute inset-0 rounded-full bg-white/40 opacity-60 animate-ping" data-id="element-38" />
      <span className="absolute inset-0 rounded-full bg-white/30 opacity-50 animate-pulse" data-id="element-39" />

      {/* Main button — glass style matching CTAs */}
      <div className="relative w-16 h-16 md:w-[72px] md:h-[72px] rounded-full glass-panel bg-white/40 backdrop-blur-2xl flex items-center justify-center shadow-[0_12px_36px_rgba(0,0,0,0.18)] border-2 border-white/70 transition-all duration-300 group-hover:scale-110 group-hover:bg-white/60 group-active:scale-95" data-id="element-40">
        <WhatsAppIcon className="w-9 h-9 md:w-10 md:h-10 text-brand-charcoal" data-id="element-41" />
      </div>

      {/* Tooltip on hover (desktop) */}
      <span className="hidden md:flex absolute right-full mr-4 top-1/2 -translate-y-1/2 whitespace-nowrap glass-panel px-4 py-2 rounded-full text-xs font-medium tracking-wide text-brand-charcoal opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 pointer-events-none" data-id="element-42">
        Aparta tu turno
      </span>
    </motion.a>;
};